import Vue              from 'vue';
import { mapActions }   from 'vuex';
import _                from 'lodash';
import axios            from 'axios';
import store            from '@/vuex/store';
import SDLUtil          from '@/utils/SDLUtil';

// export const fetchMenuAll = () => axios.get('/static/dummy/menus.json');
export const fetchMenuAll = () => axios.get(`${SDLUtil.API_URL}/basis/common/listGetMenu.skp`);
let storeMenus = [];

export default {
    async getMenus(forceRemote = false) {
        if (storeMenus.length === 0 || forceRemote) {
            try {
                const menuResponse = await fetchMenuAll();
                storeMenus = menuResponse.data;
                return storeMenus;

            } catch (err) {
                Vue.$log.error(err);
                return [];
            }

        } else {
            return Promise.resolve(storeMenus);
        }
    },
};


// WEBPACK FOOTER //
// ./src/service/skpMenuService.js